import React, {Component} from 'react';

import strings from 'strings';
import {updateStepData} from 'api';
import {
	no_words_trial,
	no_words_answers,
	nn_words_trial,
	nn_words_answers,
	no_older_version_words_trial,
	no_older_version_words_answers,
	nn_older_version_words_trial,
	nn_older_version_words_answers,
} from './assets';
import listen from 'assets/listen.png';

import './styles.scss';
import {TYPES} from '../../constants/index';
import {playSound, stopAllSounds} from 'utils/playSound';

class Trial extends Component {
	constructor(props) {
		super(props);
		const {ageGroup, testKeyType} = this.props;
		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		switch (strings.getLanguage()) {
			case 'nn':
				this.assets = isNormingTest
					? nn_words_trial
					: nn_older_version_words_trial;
				this.answers_stuff = isNormingTest
					? nn_words_answers
					: nn_older_version_words_answers;
				break;

			case 'no':
			default:
				this.assets = isNormingTest
					? no_words_trial
					: no_older_version_words_trial;
				this.answers_stuff = isNormingTest
					? no_words_answers
					: no_older_version_words_answers;
				break;
		}
	}

	componentWillReceiveProps(newProps) {
		if (newProps.currentStep !== this.props.currentStep) {
			this.startNewTask(newProps.currentStep);
		}
		if (newProps.stepData.answered && !this.props.stepData.answered) {
			this.playFeedback(newProps.currentStep, newProps.stepData.correct);
		}
	}

	componentDidMount() {
		if (this.button) this.button.click();
		this.initializeAudio();
	}
	componentWillUnmount() {
		this.stopSounds();
		clearTimeout(this.timeout);
	}

	initializeAudio = () => {
		this.timeout = setTimeout(
			() => this.startNewTask(this.props.currentStep),
			1000
		);
	};

	playFeedback = (task, correct) => {
		let audioFile;
		if (task === 0) {
			audioFile = correct
				? this.answers_stuff.correct1
				: this.answers_stuff.incorrect1;
		} else if (task === 1) {
			audioFile = correct
				? this.answers_stuff.correct1
				: this.answers_stuff.incorrect2;
		} else if (task === 2) {
			audioFile = correct
				? this.answers_stuff.correct1
				: this.answers_stuff.incorrect2;
		}

		if (audioFile) {
			playSound(audioFile, {
				onend: () => {
					setTimeout(() => {
						updateStepData({feedbackDone: true});
					}, 2000);
				},
			});
		}
	};

	startNewTask = (taskNumber) => {
		this.stopSounds();
		this.playSound(taskNumber);
	};

	playSound = (sound) => {
		const src = this.assets[sound];
		if (!src) return;

		playSound(src);
	};

	stopSounds = () => {
		stopAllSounds();
	};

	render() {
		const {testKeyType, ageGroup} = this.props;
		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		return (
			<div className="WorkingMemory">
				<img className="listen-image" src={listen} alt="" />
				{!isNormingTest && <p>{strings.wsw_test1}</p>}
			</div>
		);
	}
}

export default Trial;
